import React from 'react'
import moment from 'moment'
import GatsbyConfig from '../../../gatsby-config.js'
import onLocationIcon from '../../../static/images/onlocation-icon.png'

const { siteMetadata: config } = GatsbyConfig

export default class OnLocationBanner extends React.Component {
  render() {
    const { trip } = this.props
    const tripData = config.trips[trip]
    const ext = this.props.extension ? '-extension' : ''
    const cutoffDateUTC = moment.utc(tripData.onLocationPricingCutoff)

    return (
      <div className="banner sale-banner onlocation-banner">
        <div className="wrap">
          <span className="sale-icon">
            <img src={onLocationIcon} alt="" />
          </span>
          <span className="message">
            On-Location Sale
            <mark>
              Ends {cutoffDateUTC.utcOffset(-7).format('MMMM D - ha')} PST
            </mark>
          </span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/onlocation-banner.js